import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Sales from "../../../assets/img/SolutionsIcons/AgilysysSales&Catering.svg";
import { Header } from "../../../components/Header";

const SalesFPage = () => {
    return (
      <div className="page splash salesFPage">
        <div className="page-title">
          <img src={Sales} alt="" />
        </div>
        <Header />
        <div className="text-blocks">
          <div className="std-text">
            A cloud-native comprehensive sales & event management system that
            provides powerful tools for higher education institutions of all
            sizes. With a complete view of every group and event, the system
            fully exposes the value of each attendee and group across meeting
            and shoulder dates.{"\n\n"}
          </div>
          <div className="std-text">
            The result is improved event revenue opportunities and streamlined
            management enabling event planners and sales teams to more
            efficiently sell, manage and service their clients.
          </div>
        </div>
        {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
        <img
          className="img-1"
          src={
            "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/Catering1.png"
          }
          alt=""
        />
      </div>
    );
}

export default SalesFPage;